import { create } from 'zustand';

import { ConfirmationObserver } from './ConfirmationObserver';

interface ConfirmNavigationDialogState {
  // Message is kept even when the dialog is closed, ensuring all motion work as intended
  readonly data:
    | { readonly open: true; readonly message: string }
    | { readonly open: false; readonly message?: string };
  readonly observer: ConfirmationObserver;
}

type ConfirmNavigationDialogActions = {
  readonly [K in keyof Omit<ConfirmNavigationDialogState, 'observer'> as `set${Capitalize<K>}`]: (
    value: ConfirmNavigationDialogState[K]
  ) => void;
};

const useStore = create<ConfirmNavigationDialogState & ConfirmNavigationDialogActions>()((set) => ({
  observer: new ConfirmationObserver(),
  data: { open: false },
  setData: (data) => set(() => ({ data })),
}));

export const useObserver = (): ConfirmationObserver => useStore((state) => state.observer);

export const useData = (): ConfirmNavigationDialogState['data'] => useStore((state) => state.data);

export const useSetDataCallback = (): ((value: ConfirmNavigationDialogState['data']) => void) =>
  useStore((state) => state.setData);
